module.exports = __webpack_public_path__ + "static/media/50_A.d90848ae.png";